<article class="release-notification-card" role="status" aria-live="polite">
  <cds-icon class="release-notification-card-icon" icon="action:info_1" width="20px" height="20px" aria-hidden="true"></cds-icon>
  <div class="release-notification-card-content" [innerHTML]="html"></div>
</article>
